"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ResizeObserverPolyfill = /*#__PURE__*/function () {
  function ResizeObserverPolyfill(callback) {
    var _this = this;

    _classCallCheck(this, ResizeObserverPolyfill);

    _defineProperty(this, "boundCheck", function () {
      var entries = _this.observables.reduce(function (entries, item) {
        var currentHeight = item.target.clientHeight;
        var currentWidth = item.target.clientWidth;

        if (item.size.height !== currentHeight || item.size.width !== currentWidth) {
          entries.push({
            target: item.target
          });
          item.size.height = currentHeight;
          item.size.width = currentWidth;
        }

        return entries;
      }, []);

      if (entries.length) {
        _this.callback(entries);
      }

      window.requestAnimationFrame(_this.boundCheck);
    });

    this.observables = [];
    this.callback = callback;
    this.boundCheck();
  }

  _createClass(ResizeObserverPolyfill, [{
    key: "observe",
    value: function observe(target) {
      this.observables.push({
        target: target,
        size: {
          height: target.clientHeight,
          width: target.clientWidth
        }
      });
    }
  }, {
    key: "unobserve",
    value: function unobserve(target) {
      this.observables = this.observables.filter(function (obj) {
        return obj.target !== target;
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.observables = [];
    }
  }, {
    key: "fireAll",
    value: function fireAll() {
      this.callback(this.observables);
    }
  }]);

  return ResizeObserverPolyfill;
}();

var _default = window.ResizeObserver || ResizeObserverPolyfill;

exports["default"] = _default;